import { Col, Form, Row } from 'antd';
import { FormField } from 'components';
import { get, omit, isEmpty, isNil } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setValidity,
  updateFormField,
  getOtp,
} from 'store/forms/actions';
import {
  formFields111,
  formFields112,
  formFields21,
  formFields22
} from './formFields';
import {
  getTaxisDataByTk,
  getTaxisDataByAbiTK,
} from 'store/forms/actions';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import {  isBeneficiary } from 'utils';
import { OtpModal } from 'components/layout/components';
import { CheckCircleOutlined } from '@ant-design/icons';

const BasicInfoBeneficiary = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const carrier = useSelector(state => state.forms.carrier);
  const task = useSelector(state => state.forms.task);
  const submissionDate = useSelector(state => state.forms.submissionDate);
  const XEDM = useSelector(state => state.forms.XEDM);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  //check submissionDate in case of return to Beneficiary from auditor
  //so means that Beneficiary need to add only Additional Documents in Documents tab
  const viewMode = isViewMode || !isBeneficiary(user.groups) || !isNil(submissionDate);
  const [otpModalOpen, setOptModalOpen] = useState(false);
  const [otpValidateParams, setOtpValidateParams] = useState({});
  const [cancelOtp, setCancelOtp] = useState('');
  const [form] = useForm();
  const legalVats = useSelector(state => state.forms.carrier.legalVats);
  const [tkOptions, setTkOptions] = useState([]);
  const equipmentType = useSelector(state => state.forms.carrier.equipmentType);
  const buildTkBuilding = useSelector(state => state.forms.carrier?.buildTkBuilding);


  // Set the initial value of isExistingConnection based on the default value of `existCon`
  useEffect(() => {
    if (!viewMode) {
      const initialExistConValue = form.getFieldValue('existCon');
      const isUpgrade = initialExistConValue === true;

      // Trigger validation if "Ναι" is selected by default
      if (isUpgrade) {
        form.validateFields(['connNum']);
      }
    }
  }, [form, viewMode]);

  useEffect(() => {

    if(buildTkBuilding === '00000' || buildTkBuilding === '' ){
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'buildTkBuilding',
          value: null,
        })
      );
    }

    if (!isNil(buildTkBuilding)) {
      if (buildTkBuilding.toString().length === 5){
        dispatch(getTaxisDataByTk(buildTkBuilding));
        form.setFieldsValue({
          buildPerfectureBuilding: null,
          abiDistrictBuilding: null,
        });
      }
    }

    if(isNil(buildTkBuilding) || buildTkBuilding.toString().length < 5) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiDistrictBuildingOptions',
          value: [],
        })
      );

      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'buildPerfectureBuildingOptions',
          value: [],
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'buildPerfectureBuilding',
          value: null,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiDistrictBuilding',
          value: null,
        })
      );
    }
  }, [buildTkBuilding]);

  useEffect(() => {

    if(carrier?.abiTk === '00000' || carrier?.abiTk === '' ){
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: null,
        })
      );
    }

    if (!isNil(carrier?.abiTk)) {
      if (carrier?.abiTk.toString().length === 5){
        dispatch(getTaxisDataByAbiTK(carrier?.abiTk));
      }
    }

    if(isNil(carrier?.abiTk) || carrier?.abiTk.toString().length < 5) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiDistrictOptions',
          value: [],
        })
      );

      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiPerfectureOptions',
          value: [],
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiPerfecture',
          value: null,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiDistrict',
          value: null,
        })
      );
    }
  }, [carrier.abiTk]);


  const handleChange = ({ key, type, event }) => {
    console.log("value:",key, type);
    let newValue;

    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
       
    if (key === 'legalEmail' && carrier?.legalEmailValidated) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: key + 'Validated',
          value: false,
        })
      );
    }

  };

  useEffect(()=>{
    if(user?.taxis_data){
      const onomasia =  user?.taxis_data?.onomasia?.split(',');
      // setTkOptions(user.taxis_data?.tks?.map(item => ({
      //   label: item.code,
      //   value: item.code,
      // })))
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalSurname',
          value: !isNil(user.taxis_data?.onomasia)
          ? onomasia[0] + ' ' + onomasia[1]
          : carrier.legalSurname
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalName',
          value: !isNil(user.taxis_data?.onomasia)
          ? onomasia[2]
          : carrier.legalName
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalFather',
          value:  !isNil(user.taxis_data?.onomasia) && 
           !isNil(onomasia[3]) && !isEmpty(onomasia[3]) ? onomasia[3] 
          : !isNil(carrier.legalFather) && !isEmpty(carrier.legalFather) ? carrier.legalFather : '-'

        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'legalVat',
          value: !isNil(user.taxis_data?.afmTrimmed)
          ? user.taxis_data?.afmTrimmed
          : carrier.legalVat,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiStreet',
          value: !isNil(user.taxis_data?.residenceAddress) &&
          !isNil(user.taxis_data?.residenceAddressNo)
            ? user.taxis_data?.residenceAddress +
              ' ' +
              user.taxis_data?.residenceAddressNo
            : carrier.abiStreet,
          })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: carrier?.abiTk,
          // !isNil(user.taxis_data?.tks)
          // ? user.taxis_data?.tks?.map(item => ({
          //   label: item.code,
          //   value: item.code,
          // }))
          // : carrier.abiTk,
        })
      ); 
    }
  },[user?.taxis_data])

  useEffect(() => {
    if(isNil(carrier?.abiTk)) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: !isNil(user.taxis_data?.residenceZipCode)
          ? user.taxis_data?.residenceZipCode
          : carrier.abiTk,
        })
      )
    }
  } ,[user.taxis_data])

  // useEffect(() => {
  //   if (tkOptions && user?.taxis_data?.tks) {
  //     const options = user?.taxis_data?.tks?.filter(item => item.code === carrier?.abiTk )
  //     .map(item => ({
  //       label: item.area,
  //       value: item.area,
  //     }));
  //   }

  //   if (tkOptions && user?.taxis_data?.tks) {
  //     const options = user?.taxis_data?.tks?.filter(item => item.code === carrier?.abiTk )
  //     .map(item => ({
  //       label: item.nomos,
  //       value: item.nomos,
  //     }));
  //   }
  // }, [carrier?.abiTk]);

  useEffect(() => {
    if (cancelOtp === 'legalEmail') {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: cancelOtp + 'Validated',
          value: false,
        })
      );
    }
  }, [cancelOtp]);

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  useEffect(() => {

    form.setFieldsValue({
      legalSurname: carrier?.legalSurname,
      legalVat: carrier?.legalVat,
      legalName: carrier?.legalName,
      legalFather: !isNil(carrier?.legalFather) && !isEmpty(carrier?.legalFather) ? carrier?.legalFather : '-',      
      abiStreet: carrier?.abiStreet,
      abiTk: carrier?.abiTk,
      abiPerfecture: carrier?.abiPerfecture,
      abiDistrict: carrier?.abiDistrict,
      existCon: carrier?.existCon,
      connNum: carrier?.connNum,
      legalAdt: carrier?.legalAdt,
      legalPhoneMobile: carrier?.legalPhoneMobile,
      legalEmail: carrier?.legalEmail,
      abiDistrictBuilding:carrier?.abiDistrictBuilding,
      buildPerfectureBuilding:carrier?.buildPerfectureBuilding,
      equipmentType:carrier?.equipmentType,
      additionalServices:carrier?.additionalServices,
      birthDate:carrier?.birthDate,
      ownerStatus:carrier?.ownerStatus,
      residence:carrier?.residence,
      ownerSurname:carrier?.ownerSurname,
      ownerFirstname:carrier?.ownerFirstname,
      ownerVat:carrier?.ownerVat,
      buildStreetBuilding:carrier?.buildStreetBuilding,
      buildTkBuilding:carrier?.buildTkBuilding,
      buildPerfectureBuilding:carrier?.buildPerfectureBuilding,
      abiDistrictBuilding:carrier?.abiDistrictBuilding,
      powerNumberBuilding:carrier?.powerNumberBuilding,
      powerSupply:carrier?.powerSupply,
      powerSupplyPrivate:carrier?.powerSupplyPrivate,
      powerSupplyPublic:carrier?.powerSupplyPublic,
      ameaMember:carrier?.ameaMember,
      legalChildren:carrier?.legalChildren,
      individualIncome:carrier?.individualIncome,
      legalIncome:carrier?.legalIncome,

    });
  }, [form, carrier]);

  const verifyOtp = fieldName => {
    const params = {
      processInstanceId: task.processInstanceId,
      fieldName: fieldName === 'legalPhoneMobile' ? 'mobile' : 'email',
      fieldValue: carrier?.[fieldName],
      field: fieldName,
    };
    setOtpValidateParams(params);
    if (carrier?.[fieldName]) {
      dispatch(getOtp(params));
      setOptModalOpen(true);
    }
  };

  return (
    <div>
      <OtpModal
        isVisible={otpModalOpen}
        setVisible={setOptModalOpen}
        otpValidateParams={otpValidateParams}
        cancelOtp={cancelOtp}
        setCancelOtp={setCancelOtp}
      />
      <Form
        form={form}
        initialValues={{
          ...carrier,
        }}
        trigger="onChange"
        className='basicInfoForm'
      >
        <div
          className="carrier-data-form"
          style={{ width: '45%', display: 'inline-block' }}
        >
          <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
            Στοιχεία Ωφελούμενου
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
            align="top"
          >
            {formFields111.map((field, index) => {
              return field.name !== 'legalEmail' ? (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    value={renderFieldValue(field)}
                    validateFirst
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled ?? viewMode}
                      {...omit(field, ['span', 'rules', 'offset', 'disabled'])}
                      options={
                        field.name === 'abiPerfecture'
                          ? carrier.abiPerfectureOptions &&
                            carrier.abiPerfectureOptions.map(b => ({
                              value: b.value,
                            }))
                          : field.name === 'abiDistrict' ? 
                          carrier.abiDistrictOptions &&
                          carrier.abiDistrictOptions.map(b => ({
                            value: b.value,
                          })) : field.options
                      }
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    value={renderFieldValue(field)}
                    validateFirst
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled ?? viewMode}
                      label={
                        <span>
                          {field.label}
                          <span className="color-asterisk">{' *'}</span>
                          {/* <a
                            onClick={e => {
                              e.preventDefault();
                              if (
                                field.name === 'legalPhoneMobile' &&
                                !carrier?.legalPhoneMobileValidated
                              )
                                verifyOtp(field?.name);
                              else if (
                                field.name === 'legalEmail' &&
                                !carrier?.legalEmailValidated
                              )
                                verifyOtp(field?.name);
                            }}
                            rel="noopener noreferrer"
                            style={{ marginLeft: 8 }}
                          >
                            {field.name === 'legalPhoneMobile' ? (
                              !carrier?.legalPhoneMobileValidated ? (
                                carrier?.legalPhoneMobileValidated === false ? (
                                  <span className="otp-button-reject">
                                    Επαλήθευση
                                  </span>
                                ) : (
                                  <span>Επαλήθευση</span>
                                )
                              ) : (
                                <span style={{ color: '#2E9544' }}>
                                  Επαληθεύτηκε <CheckCircleOutlined />
                                </span>
                              )
                            ) : !carrier?.legalEmailValidated ? (
                              carrier?.legalEmailValidated === false ? (
                                <span className="otp-button-reject">
                                  Επαλήθευση
                                </span>
                              ) : (
                                <span>Επαλήθευση</span>
                              )
                            ) : (
                              <span style={{ color: '#2E9544' }}>
                                Επαληθεύτηκε <CheckCircleOutlined />
                              </span>
                            )}
                          </a> */}
                        </span>
                      }
                      {...omit(field, [
                        'span',
                        'rules',
                        'offset',
                        'disabled',
                        'label',
                        'asterisk',
                      ])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
        <div
          className="carrier-data-form move-up"
          style={{ width: '45%', display: 'inline-block', marginLeft: '10%' }}
        >
          <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
            Στοιχεία Ακινήτου
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields112(carrier?.ownerStatus).map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span} >
                  <Form.Item
                    name={[field.name]}
                    rules={
                      field.name === 'buildLegalVat'
                        ? [
                            ...field.rules,
                            {
                              required: true,
                              message: 'Το πεδίο είναι υποχρεωτικό',
                            },
                          ]
                        : field.rules
                    }
                    validateFirst
                    value={renderFieldValue(field)}
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled ?? viewMode}
                      {...omit(field, ['span', 'rules', 'disabled'])}
                      options={
                        field.name === 'buildPerfectureBuilding'
                          ? carrier.buildPerfectureBuildingOptions &&
                            carrier.buildPerfectureBuildingOptions.map(b => ({
                              value: b.value,
                            }))
                          : field.name === 'abiDistrictBuilding' ? 
                          carrier.abiDistrictBuildingOptions &&
                          carrier.abiDistrictBuildingOptions.map(b => ({
                            value: b.value,
                          })) : field.options
                      }
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
            {/* <p className="mt-6 mr-0 w-100 color-blue-3 text-bold font-size-24">
              Στοιχεία κριτηρίων
           </p>
          {equipmentType ==='equipmentTypeThermosifonas' && formFields22.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span} >
                  <Form.Item
                    name={[field.name]}
                    rules={
                      field.name === 'buildLegalVat'
                        ? [
                            ...field.rules,
                            {
                              required: true,
                              message: 'Το πεδίο είναι υποχρεωτικό',
                            },
                          ]
                        : field.rules
                    }
                    validateFirst
                    value={renderFieldValue(field)}
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled ?? viewMode}
                      {...omit(field, ['span', 'rules', 'disabled'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          {formFields21.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span} >
                  <Form.Item
                    name={[field.name]}
                    rules={
                      field.name === 'buildLegalVat'
                        ? [
                            ...field.rules,
                            {
                              required: true,
                              message: 'Το πεδίο είναι υποχρεωτικό',
                            },
                          ]
                        : field.rules
                    }
                    validateFirst
                    value={renderFieldValue(field)}
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled ?? viewMode}
                      {...omit(field, ['span', 'rules', 'disabled'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })} */}
          </Row>
        </div>
      </Form>
    </div>
  );
};

export default BasicInfoBeneficiary;
